import { FC } from 'react';
import { UseFormRegister, UseFormSetValue, FieldErrors } from 'react-hook-form';
import Card from 'components/Card';
import CrawlerOptionsDisclosure from 'pages/crawler/components/form/CrawlerOptionsDisclosure';
import CrawlerNotificationPreferences from 'pages/crawler/components/form/CrawlerNotificationPreferences';
import AdvancedOptionsDisclosure from 'pages/crawler/components/form/AdvancedOptionsDisclosure';
import { CrawlerFormData } from 'pages/crawler/types';
import { CallbackTestResult } from 'pages/crawler/hooks/useCrawlerForm';

interface CrawlerFormSectionsProps {
  register: UseFormRegister<CrawlerFormData>;
  setValue: UseFormSetValue<CrawlerFormData>;
  errors: FieldErrors<CrawlerFormData>;
  watchedValues: CrawlerFormData;
  testCallback: () => void;
  isTestingCallback: boolean;
  callbackTestResult: CallbackTestResult;
  setCallbackTestResult: (result: CallbackTestResult) => void;
}

/**
 * Shared form sections component for crawler forms
 * Renders the three main sections: Options, Notifications, and Advanced Options
 */
export const CrawlerFormSections: FC<CrawlerFormSectionsProps> = ({
  register,
  setValue,
  errors,
  watchedValues,
  testCallback,
  isTestingCallback,
  callbackTestResult,
  setCallbackTestResult,
}) => {
  return (
    <>
      {/* Crawler Options */}
      <Card className="my-4 border border-[#e5eaee] bg-[#f7f9fa] !overflow-visible">
        <CrawlerOptionsDisclosure
          register={register}
          watchedValues={watchedValues}
          setValue={setValue}
          testCallback={testCallback}
          errors={errors}
          isTestingCallback={isTestingCallback}
          callbackTestResult={callbackTestResult}
          setCallbackTestResult={setCallbackTestResult}
        />
      </Card>

      {/* Notification Preferences */}
      <Card className="my-4 border border-[#e5eaee] bg-[#f7f9fa]">
        <CrawlerNotificationPreferences
          watchedValues={watchedValues}
          setValue={setValue}
        />
      </Card>

      {/* Advanced Options */}
      <Card className="border border-[#e5eaee] bg-[#f7f9fa] mb-4 !overflow-visible">
        <AdvancedOptionsDisclosure
          watchedValues={watchedValues}
          setValue={setValue}
        />
      </Card>
    </>
  );
};
